var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-autocomplete", {
    attrs: {
      items: _vm.dataSourceView,
      "item-text": "text",
      "item-value": "value",
      label: "Seleziona elementi",
      "return-object": "",
      multiple: "",
      chips: "",
      clearable: "",
      filled: "",
      "menu-props": { top: false, offsetY: true },
    },
    model: {
      value: _vm.values,
      callback: function ($$v) {
        _vm.values = $$v
      },
      expression: "values",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }